module.exports = __webpack_public_path__ + "static/media/token.e93a3738.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/token.png
// module id = 615
// module chunks = 0